import { createSelector } from 'reselect';

const metaInfo = (store) => store.SpacesListing.loadSpaces.data?.meta || {};

const getSpaceSorterTitle = createSelector(metaInfo, (meta) => {
	if (!meta.totalCount) {
		return '';
	}

	return `${t('Найдено')} ${t(
		'{n} пространство|{n} пространства|{n} пространств',
		meta.totalCount,
	)}`;
});

export default getSpaceSorterTitle;
